import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AuthService } from './code/auth-service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AsyncPipe } from '@angular/common';
import { PageHelper } from './code/PageHelper';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppInitService } from './code/app-init-service';
import { LoggerModule, NGXLogger } from 'ngx-logger';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { MyNavService } from './code/MyNav.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StorageService } from './code/storage-service';
import { ShareModule } from './code/share-module';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { SwipeModule } from './code/component/Swipe.module';
import { MyConfigService } from './code/my-config.service';
import { Drivers } from '@ionic/storage';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GoService } from './code/go-service';
import { QuizService } from './code/quiz-service';
import { SearchService } from './code/search-service';
import { HttpTokenInterceptor } from './code/HttpTokenInterceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalVarService } from './code/globalvar-service';
import { NgxEchartsModule } from 'ngx-echarts';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FeatureService } from './feature.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AutocompleteLibModule,
    BrowserModule,
    CKEditorModule,
    CommonModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({ name: '_ehs_db', driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage] }),
    LoggerModule.forRoot(environment.logging),
    AppRoutingModule,
    HttpClientModule,
    SwipeModule,
    ShareModule,
    HammerModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleTagManagerModule.forRoot({ id: "GTM-MN539MC" }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    TranslateModule.forRoot({ 
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: 'googleTagManagerId', useValue: "GTM-MN539MC" },
    AsyncPipe, AuthService, PageHelper, StorageService, GoService, QuizService, SearchService,
    MyNavService, AppInitService, MyConfigService, GlobalVarService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService, log: NGXLogger) => function () {
        return appInitService.load();
      },
      deps: [AppInitService, NGXLogger, AuthService, GlobalVarService],
      multi: true
    },
    provideAnimationsAsync(),
    FeatureService,
    NgxImageCompressService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }